module.exports = __webpack_public_path__ + "static/media/intro.24b40bbe.md";


//////////////////
// WEBPACK FOOTER
// ./src/guides/intro.md
// module id = 250
// module chunks = 0